
import {LocalDate} from '@js-joda/core';
import {EntityModel} from '../core/model/entity.model';

export enum PurchaseProcessStatus {
  PUBLISHED = 'PUBLISHED',
  OFFER_RECEPTION = 'OFFER_RECEPTION',
  EVALUATION = 'EVALUATION',
  AWARDED = 'AWARDED',
  FIRMLY_AWARDED = 'FIRMLY_AWARDED',
  CONTRACT = 'CONTRACT',
  UNSUCCESSFUL = 'UNSUCCESSFUL',
  DESERTED = 'DESERTED',
  CLEARED = 'CLEARED',
}

export class PurchaseProcessDocument {
  public sequence?: string;
  public total?: number;
  public date?: LocalDate;
  public issuer?: string;
  public key?: string;
}

export class PurchaseProcessLine extends EntityModel {
  public purchaseAmount?: number;
  public purchaseRequestLine?: number;
  public accountName?: string;
  public accountCode?: string;
  public sicopNumber?: string;
}

export class PurchaseProcess extends EntityModel {
  public sicopNumber?: string;
  public status?: PurchaseProcessStatus;
  public purchaseAmount?: number;
  public awardDate?: LocalDate;
  public unsuccessfulDate?: LocalDate;
  public purchaseRequest?: number;
  public documents?: PurchaseProcessDocument[];
  public lines: PurchaseProcessLine[] = [];
}
